import {
  Button,
  Box,
  HStack,
  Text,
  useDisclosure,
  IconButton,
} from "@chakra-ui/react";
import SelectionModal from "./SelectionModal";

import { ReactComponent as TransferArrow } from "assets/svg/transfer-arrow.svg";
import { useCallback, useRef, useState } from "react";

import capitalize from "lodash/capitalize";

export default function WalletTransfer(props) {
  const { _from, _to, _swap, values, onChange, ...xprops } = props;
  const whichWasClicked = useRef("none");
  const { isOpen, onClose, onOpen } = useDisclosure();

  const [state, setState] = useState({
    from: "earn",
    to: "main",
    ...(values ?? {}),
  });

  const set = useCallback(
    (update) => {
      setState((old) => ({ ...old, ...update }));
      onChange && onChange({ ...state, ...update });
    },
    [onChange, state]
  );

  const handleClick = (clickedOn) => {
    onOpen();
    whichWasClicked.current = clickedOn;
  };

  const handleSelect = (update) => {
    if (whichWasClicked.current === "to") set({ to: update });
    if (whichWasClicked.current === "from") set({ from: update });
  };

  const swapSelection = () => {
    set({ from: state.to, to: state.from });
  };

  return (
    <>
      <Box pos="relative" borderRadius="16px" w="100%" {...xprops}>
        <Button
          variant="unstyled"
          bg="#EFF0F6"
          p="20px 24px"
          borderRadius="16px 16px 0 0"
          minW="fit-content"
          minH="fit-content"
          h="fit-content"
          w="100%"
          d="block"
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
          onClick={() => handleClick("from")}
          {..._from}
        >
          <HStack alignItems="center">
            <Text
              w="38px"
              fontSize="14px"
              color="#A0A3BD"
              alignSelf="flex-start"
              textAlign="left"
            >
              From
            </Text>
            <Text fontWeight="500">{capitalize(state.from)}</Text>
          </HStack>
        </Button>
        <Button
          variant="unstyled"
          bg="#EFF0F6"
          p="20px 24px"
          borderRadius="0 0 16px 16px"
          minW="fit-content"
          minH="fit-content"
          h="fit-content"
          w="100%"
          d="block"
          mt="3px"
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
          onClick={() => handleClick("to")}
          {..._to}
        >
          <HStack alignItems="center">
            <Text
              w="38px"
              fontSize="14px"
              color="#A0A3BD"
              alignSelf="flex-start"
              textAlign="left"
            >
              To
            </Text>
            <Text fontWeight="500">{capitalize(state.to)}</Text>
          </HStack>
        </Button>

        <IconButton
          size="md"
          pos="absolute"
          right="20px"
          top="50%"
          transform="translateY(-50%)"
          bg="transparent"
          color="black"
          minW="fit-content"
          aria-label="swap values"
          icon={<Box boxSize="32px" as={TransferArrow} />}
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
          _hover={{ bg: "transparent", color: "#03A438" }}
          onClick={swapSelection}
          {..._swap}
        />
      </Box>

      <SelectionModal
        isOpen={isOpen}
        onClose={onClose}
        values={state}
        onSelect={handleSelect}
        modalFor={whichWasClicked.current}
      />
    </>
  );
}
